export const customFetch = (uri, options) =>
  fetch(uri, options).then(response => {
    if (response.status >= 500) {
      return Promise.reject(response.status);
    }
    return response;
  });
